import { Typography, Box } from '@wishket/design-system';
import Link from 'next/link';

import { twJoin } from 'tailwind-merge';

import { HighlightedStatementCardProps } from './types';
import { cardBackgroundColor } from './constants';
import { ArrowIcon } from './HighlightedStatementCard.parts';

const HighlightedStatementCard = ({
  highlightedStatement,
  title,
  link,
  color,
}: HighlightedStatementCardProps) => {
  const backgroundColor = cardBackgroundColor[color];

  return (
    <Link
      href={link}
      className={twJoin(
        backgroundColor,
        'flex h-[230px] w-[210px] flex-col justify-between rounded-2xl p-5',
        'transition-transform tablet:h-[238px] tablet:w-[360px] tablet:rounded-3xl tablet:p-8 tablet:hover:-rotate-3'
      )}
      data-testid="landing-most-highlighted-statement-card"
    >
      <Typography
        variant="body1"
        className={twJoin(
          'line-clamp-5 font-bold',
          'tablet:line-clamp-3 tablet:typo-subTitle2'
        )}
        data-testid="landing-most-highlighted-statement-card-text"
      >
        {highlightedStatement}
      </Typography>
      <Box className="flex items-center justify-between gap-3">
        <Typography variant="body1" className="truncate font-medium">
          {title}
        </Typography>
        <Box className="shrink-0">
          <ArrowIcon />
        </Box>
      </Box>
    </Link>
  );
};

export default HighlightedStatementCard;
